function getUserType(permissions: any) {
  if (permissions?.length) {
    if (permissions.includes("admin")) {
      return "Admin";
    } else if (permissions.length === 1 && permissions.includes("student")) {
      return "Student";
    } else if (
      permissions.includes("atc.edit") ||
      permissions.includes("atc.view")
    ) {
      return "ATC";
    } else {
      return "Admin";
    }
  }
}

export default getUserType;
